export const ConcurrencyInfo = [
  {
    color: 'green',
    runningCount: '20',
    total: '200',
  },
  {
    color: 'orange',
    runningCount: '100',
    total: '200',
    hideTotal: true,
  },
];

export const toasterStyle = { top: 24, right: 24, zIndex: 9999999 };
